<template>
  <highcharts :options="chartOptions"></highcharts>
</template>

<script>

export default {
  name: 'MiniGauge',
  props : {
    libelle: String,
    unite: {
      type: String,
      default: '%'
    },
    valeur: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      default : 0
    },
    max: {
      type: Number,
      default: 100
    }
  },
  data() {
    var vm = this
    return {
      chartOptions: {
        chart: {
            type: 'solidgauge',
            style: {
              fontFamily: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\""
            }
        },
        series: [{
          data: [this.valeur] // sample data
        }],
        pane: {
            center: ['50%', '40%'],
            size: '80%',
            startAngle: -150,
            endAngle: 150,
            background: {
                innerRadius: '85%',
                outerRadius: '100%',
                shape: 'arc'
            }
        },
        plotOptions: {
            solidgauge: {
              dataLabels: {
                y: -25,
                formatter: function() { return '<center><span style="font-size:30px;">' + this.y + '</span><br />' + vm.unite + '</center>'; },
                borderWidth: 0,
                useHTML: true
              },
              innerRadius: '85%',
              outerRadius: '100%'
            }
        },
        yAxis: {
          min: this.min,
          max: this.max,
          lineWidth: 0,
          minorTicks: false,
          showFirstLabel: false,
          showLastLabel: false,
          tickAmount: 0,
          tickWidth: 0
        },
        credits: {
          enabled: false
        },
        title: {
          verticalAlign: 'bottom',
          text: this.libelle,
          widthAdjust: 0,
          y: -13
        },
        tooltip: {
          enabled: false
        }
      }
    }
  }
}
</script>

<style scoped>
div {
  width: 150px;
  height: 150px;
}
</style>
